import img1 from '../images/whisgars/318411702_2595018513980473_2871872510464920757_n(1).webp';
import img2 from '../images/whisgars/whisgars-atmosphere-11.webp';
import img3 from '../images/whisgars/whisgars-atmosphere-13.webp';
import img4 from '../images/whisgars/whisgars-atmosphere-14.webp';
import img5 from '../images/whisgars/whisgars-atmosphere-2.webp';

export const whisgarsImages = [img1, img2, img3, img4, img5];
